export enum PRODUCT_TYPES {
  PAYPAL = 'PAYPAL',
  PREPAID = 'PREPAID',
}
